export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8467.e486a669.jpg";